const userRoles = {
  admin: 'Administrador',
  adminProInfo: 'AdminProInfo',
  adminIl: 'AdminIL',
  adminSaee: 'AdminSAEE',
  director: 'Director',
  maestro: 'Maestro',
  directorCentro: 'Director Centro',
  tecnico: 'Técnico',
  facilitador: 'Facilitador',
  facilitadorRegion: 'Facilitador_Region',
  facilitadorDistrito: 'Facilitador-Distrito',
  facilitadorMunicipios: 'Facilitador-Municipios',
  roleName: 'RoleName',
  adminProvider: 'AdminProvider',
  adminProviderCenter: 'AdminProvider - Centro',
  interventorCenter: 'Interventor - Centro',
  center: 'Centro',
  adminKnumetrix: 'AdminKnumetrix',
  adminRsm: 'AdminRSM',
  technicalAssistence: 'Asistencia Técnica',
  centeIsland: 'Centro-Isla',
  consultant: 'Consultor',
  legalDivision: 'Division Legal - Unidad Seguimiento',
  central: 'Central',
  especialista: 'Especialista',
  provider: 'Provider',
  assistantprovider: 'Asistente Proveedor',
  proveedorcpa: 'Proveedor CPA',
  directorPrivado: 'Director Privado',
  maestroPrivado: 'Maestro Privado',
  maestroIngles: 'Maestro de Inglés',
  maestroCiego: 'Maestro Ciego',
  maestroSordo: 'Maestro de Sordos',
  partCPartB: 'Parte C a Parte B',
  AuxiliarAdministrativoEscolar: 'Auxiliar Administrativo Escolar',
  ProviderPagoDirecto: 'Provider-Pago Directo',
  MaestroItinerante: 'Maestro Itinerante',
};

export default userRoles;
